<template>
  <div>
    <div v-if="loading" class="all-center">
      <Loading />
    </div>

    <div class="main">
      <section v-if="!loading" class="content pt-7">
        <div @click="goHome">
          <v-img
            class="ml-3 mb-4 pointer"
            width="150"
            src="../../../assets/logo-white.svg"
          ></v-img>
        </div>

        <p class="text-h6 title">
          Solução temporária {{ info.centro }}
        </p>
        <div class="solution">
          <div v-if="found">
            <div :class="[isMobile ? 'px-0 pt-4' : 'pa-4']">
              <!-- <PaasSolution :title="info.description" :plan="solution" :initRoom="roomParam" searchEmptyRoom occupancyRate /> -->
              <PaasSolution
                :title="
                  `Plano: ${info.name}. Criado por ${info.user}.`
                "
                :plan="solution"
              />
              <p class="mt-6 all-center text-caption">
                Plano criado em {{ info.date }}.
              </p>
            </div>
          </div>
          <div class="all-center pa-4" v-else>
            <NotFound
              :title="'Não encontrado'"
              btn="Ir para home"
              :btnFunction="goHome"
              :text="`A alocação de aulas não está disponível.`"
            />
          </div>

          <PublicFooter class="pb-6" :year="footerYear" />
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/Loading.vue";
import PaasSolution from "@/components/paas/PaasSolution.vue";
import NotFound from "@/components/NotFound.vue";
import PublicFooter from "@/components/PublicFooter.vue";

import { findSharedPlan } from "@/api/paas/plans";
import { formatDayAndTime } from "@/utils/Format"
//import { getCenterInfo } from "@/api/paas/center";

export default {
  name: "PaasTemp",
  metaInfo: {
    title: "SACI",
    meta: [
      { charset: "utf-8" },
      {
        name: "description",
        content: `Alocação de aulas a salas.`
      }
    ]
  },
  components: {
    Loading,
    PaasSolution,
    NotFound,
    PublicFooter
  },
  data() {
    return {
      solution: [],
      id: "",
      info: {
        centro: "",
        date: "",
        name: "",
        user: ""
      },
      loading: true,
      found: false
    };
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.width < 570;
    },
    footerYear() {
      const dateYear = String(this.info.date || "").match(
        /\b(19|20)\d{2}\b/
      );
      return dateYear ? dateYear[0] : new Date().getFullYear();
    }
  },
  created() {
    this.$store.commit("setCurrentComponent", {
      component: "Public"
    });
  },

  methods: {
    //finds room index passed trough param
    findRoomIndex(room) {
      //create a array of room names, ex: {bloco: 'CI', sala: '101'} -> 'ci-101'
      let roomList = this.solution.solution.map(el =>
        `${el.bloco}-${el.nome}`
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .replace(/[\W_]+/g, "-")
          .toLowerCase()
          .replace(/^-+|-+$/g, "")
      );
      //set index found
      this.roomParam = roomList.findIndex(
        e => e == room.toLocaleLowerCase()
      );
    },
    goHome() {
      this.$router.replace({ name: "Home" });
    }
  },

  async mounted() {
    this.id = this.$route.params.hash;

    findSharedPlan(this.id)
      .then(res => {
        this.solution = res.solution;
        this.info.centro = res.centro;
        this.info.user = res.user;
        this.info.name = res.name;
        this.info.date = formatDayAndTime(res.date);
        this.found = true;
        console.log(res);
      })
      .finally(() => {
        this.loading = false;
      });

    //get solution on database
    //let res = await getCenterInfo(center);
  }
};
</script>

<style scoped>
.main {
  /* background: url('../assets/saci-pattern-opacity.png'), linear-gradient(50deg, rgba(71,118,230,1) 0%, rgba(142,84,233,1) 100%);; */
  /* background: url('../assets/saci-pattern-opacity.png'), linear-gradient(135deg, #1491ff, #0346b6); */
  /* background: rgb(71,118,230); */
  /* background: linear-gradient(50deg, rgba(71,118,230,1) 0%, rgba(142,84,233,1) 100%); */
  background: linear-gradient(135deg, #1491ff, #0346b6);
  min-height: 100vh;
}

.content {
  margin: 0 auto;
  max-width: 1800px;
}

.solution {
  padding: 0;
  border-radius: 30px 30px 0 0;
  margin: 0 10px;
  min-height: 90vh;
  background-color: white;
}

.title {
  margin-left: 15px;
  color: white;
}

.center {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.all-center {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.pointer {
  cursor: pointer;
}

</style>
